import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IAuthRepository } from '../../repositories/interfaces/iAuthRepository';
import { IForgotPasswordSendOTPResponse } from '../../../entity/interface/iAuthApis';

export interface IForgotPasswordResendOTPUseCase {
    execute(
        username: string,
        lang: string,
        apiToken: { [key: string]: string },
        recaptchaToken: string | null
    ): Promise<IForgotPasswordSendOTPResponse>;
}

export class ForgotPasswordResendOTPUseCase implements IForgotPasswordResendOTPUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get authRepo(): IAuthRepository {
        return container.resolve<IAuthRepository>(DI.REPOSITORIES.IAuthRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(
        username: string,
        lang: string,
        apiToken: { [key: string]: string },
        recaptchaToken: string | null
    ): Promise<IForgotPasswordSendOTPResponse> {
        return await this.authRepo.forgotPasswordResendOTP(username, lang, apiToken, recaptchaToken);
    }
}
